"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyToken = void 0;
exports.emptyToken = { id: 1 };
//# sourceMappingURL=empty-token.js.map